<template>
  <b-spinner
    v-if="modalLoading"
    variant="secondary"
    role="status"
    size="sm"
    class="wizard-spinner"
    style="top: 15%"
  />
  <div class="content-cont" v-else>
    <p class="header-title">RFID Enrollment</p>
    <div class="hint-modal">
      <p
        v-if="email || phone"
        class="first-msg vp-font-weight-700 vp-font-size-16 vp-color-grey-2 vp-mt-0"
      >
        {{ fullName }}
        {{
          hasPassport
            ? "already has a"
            : isDeactivated
            ? "has a “Deactivated”"
            : "doesn’t have a"
        }}
        VisiPoint Passport account.
      </p>

      <p
        v-else-if="noKiosks"
        class="first-msg vp-font-weight-700 vp-font-size-16 vp-color-grey-2 vp-mt-0"
      >
        No kiosks are available to print.
      </p>

      <p
        v-else
        class="first-msg vp-font-weight-700 vp-font-size-16 vp-color-grey-2 vp-mt-0"
      >
        {{ fullName }} doesn’t have an email address or phone number.
      </p>

      <template v-if="email || phone">
        <p class="second-msg" v-if="hasPassport">
          Are you sure you want to send the RFID enrollment instructions?
        </p>
        <p class="pass-ques" v-else>
          Are you sure you want to create a
          {{ isDeactivated ? "Local QuickPass" : "VisiPoint Passport" }} for
          them and send the RFID enrollment instructions?
        </p>
      </template>

      <template v-else-if="noKiosks">
        <p class="pass-ques">
          {{ fullName }} doesn’t have an email address or phone number, and
          there are no kiosks available to print a badge for them showing their
          Local QuickPass.
        </p>
      </template>

      <template v-else>
        <p class="pass-ques">
          Are you sure you want to print a badge for them showing their Local
          QuickPass?
        </p>
      </template>

      <template v-if="checkingKiosk">
        <div class="loader-con d-flex">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span class="padge-txt">
            Print badge showing the
            {{ hasPassport || noPassport ? "Passport" : "Local" }}
            QuickPass.</span
          >
        </div>
      </template>

      <template v-else-if="email || phone">
        <div class="check-box-con">
          <b-form-checkbox
            id="print-checkbox"
            class="printCheckbox"
            v-model="printChecked"
            @change="checkKiosk()"
          >
            <span class="print-padge-txt1">
              Print badge showing the
              {{ hasPassport || noPassport ? "Passport" : "Local" }}
              QuickPass.
            </span>
          </b-form-checkbox>
        </div>
        <p class="error-msg" v-if="noKiosks">
          No kiosks are available for printing.
        </p>
        <div class="kiosk-ddl">
          <span class="kiosk-label" v-if="kioskToPrint"
            >Kiosk to print from</span
          >
          <treeselect
            v-if="printChecked"
            v-model="kioskToPrint"
            id="attendance-code"
            class="attendance-code"
            :multiple="false"
            :options="kioskOptions"
            :clearOnSelect="true"
            :flat="false"
            :default-expand-level="0"
            placeholder="Kiosk to print from"
          />
        </div>
      </template>

      <template v-else-if="!noKiosks">
        <div class="kiosk-ddl">
          <span class="kiosk-label" v-if="kioskToPrint"
            >Kiosk to print from</span
          >
          <treeselect
            v-model="kioskToPrint"
            id="attendance-code"
            class="attendance-code"
            :multiple="false"
            :options="kioskOptions"
            :clearOnSelect="true"
            :flat="false"
            :default-expand-level="0"
            placeholder="Kiosk to print from"
          />
        </div>
      </template>
    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button
        v-if="email || phone"
        @click="onSubmit()"
        class="submit-action-btn btn btn-primary"
        size="md"
        :disabled="isLoading || (printChecked && !kioskToPrint)"
      >
        <i
          v-if="isLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        {{ noPassport ? "Create" : "Send" }}
      </button>
      <button
        v-else-if="noKiosks"
        class="submit-action-btn btn btn-primary"
        size="md"
        style="margin-inline-end: 0px !important"
        @click="
          $bvModal.hide('rfidEnrollmentModal');
          $bvModal.hide(getModalInfo.modalId);
        "
      >
        Okay
      </button>
      <button
        v-else
        @click="onSubmit()"
        class="submit-action-btn btn btn-primary"
        size="md"
        :disabled="isLoading || !kioskToPrint"
      >
        <i
          v-if="isLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        Print
      </button>

      <button
        v-if="email || phone || !noKiosks"
        @click="
          $bvModal.hide('rfidEnrollmentModal');
          $bvModal.hide(getModalInfo.modalId);
        "
        class="cancel-btn"
        type="button"
        :disabled="getLoading"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";

export default {
  components: {
    Treeselect,
  },
  name: "RFIDEnrollment",
  data() {
    return {
      user_id: null,
      fullName: null,
      email: "",
      phone: "",
      noPassport: false,
      hasPassport: false,
      isDeactivated: false,
      checkingKiosk: false,
      printChecked: false,
      kioskToPrint: null,
      isLoading: false,
      noKiosks: false,
      modalLoading: false,
      kioskOptions: [],
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("users", ["getModalState", "getLoading"]),
  },
  methods: {
    ...mapActions("users", ["resetLoading"]),
    ...mapActions("setting", ["sendInstructions", "getOnlineKiosks"]),
    async checkKiosk() {
      console.log("checkKiosk", this.printChecked);
      this.noKiosks = false;
      this.kioskToPrint = null;
      if (this.printChecked) {
        this.checkingKiosk = true;
        const result = await this.getOnlineKiosks();
        console.log("onlinekisok", result);
        this.kioskOptions = result.data.map((item) => {
          return {
            id: item.id,
            label: item.name,
          };
        });
        if (this.kioskOptions.length == 0) {
          this.noKiosks = true;
          this.printChecked = false;
        }
        this.checkingKiosk = false;
      }
    },
    async onSubmit() {
      console.log("kioskToPrint", this.kioskToPrint);
      const { user_id } = this;
      this.isLoading = true;
      await this.sendInstructions({
        user_id,
        entity_id: this.getModalInfo.current_entity.entity_id,
        kiosk_id:
          this.printChecked || (!this.email && !this.phone)
            ? this.kioskToPrint
            : null,
        single: true,
      });
      this.$bvModal.hide("rfidEnrollmentModal");
      this.isLoading = false;
      if (this.noPassport && (this.email || this.phone))
        this.$emit("changeUserPassportStatus", user_id);
    },
  },
  beforeMount() {
    this.resetLoading();
  },
  async mounted() {
    console.log("this.getModalInfo", this.getModalInfo);
    if (this.getModalInfo) {
      if (
        this.getModalInfo.user_passport &&
        this.getModalInfo.user_passport.is_active == 0
      ) {
        this.isDeactivated = true;
      } else if (this.getModalInfo.user_passport == null) {
        this.noPassport = true;
      } else if (
        this.getModalInfo.user_passport &&
        this.getModalInfo.user_passport.is_active == 1
      ) {
        this.hasPassport = true;
      }

      const { id, fullName, email, phone } = this.getModalInfo;
      this.user_id = id;
      this.fullName = fullName;
      this.email = email;
      this.phone = phone;

      if (!email && !phone) {
        this.modalLoading = true;
        const result = await this.getOnlineKiosks();
        this.kioskOptions = result.data.map((item) => {
          return {
            id: item.id,
            label: item.name,
          };
        });
        if (this.kioskOptions.length == 0) {
          this.noKiosks = true;
        }
        this.modalLoading = false;
      }
    }
  },
};
</script>

<style lang="scss">
div[id*="rfidEnrollmentModal"] {
  // background: #F3F3F3;
  // padding-inline-end:0px!important;
  // border-radius: 26px;

  div[id*="___BV_modal_content_"] {
    width: 579px !important;

    margin-top: 120px;
    margin-bottom: 100px;
    border-radius: 26px !important;
  }
  .modal-content .modal-body {
    // padding: 0px !important;
    // border-radius: 26px;
    p.header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 40px;
      color: #000000;
    }
    .hint-modal {
      width: 469px;
      margin: auto;
      .vue-treeselect__menu::-webkit-scrollbar {
        width: 9px;
        height: 30px !important;
      }
      .vue-treeselect__menu::-webkit-scrollbar-track {
        background: #c7c7c7;
        padding-top: 30px !important;
        border-radius: 8.5px;
        -webkit-box-shadow: #ffff;
        margin-top: 21px !important;
        margin-bottom: 13px !important;
      }
      .vue-treeselect__menu::-webkit-scrollbar-thumb {
        background: #666666;
        border-radius: 8.5px;
      }
      .vue-treeselect__list {
        width: 413px;
        // max-height: 110px !important;
      }
      // .vue-treeselect__menu {
        // max-height: 110px !important;
      // }
      .vue-treeselect__option {
        border-top: 1px solid #ebebeb;
        // padding-inline-end: 10px;
      }
      .vue-treeselect__label {
        font-size: 16px;
        font-weight: 400;
        font-size: 16px;
        color: #787878;
        padding-inline-start: 12px;
        padding-top: 10px;
        padding-bottom: 10px;
        white-space: normal;
      }
      .vue-treeselect__list-item {
        width: 98% !important;
      }

      .vue-treeselect__list:first-of-type
        > .vue-treeselect__list-item:first-of-type
        > .vue-treeselect__option:first-of-type {
        border-top: none;
      }
      .vue-treeselect__input-container {
        font-size: 16px;
        margin-top: 15px;
        padding-inline-start: 15px;
      }
      .spinner-border {
        width: 18px;
        height: 18px;
        margin-top: 5px;
        color: #8c8c8c;
      }
      .loader-con {
        width: 350px;
        margin: 24px auto 0px auto;
      }
      .padge-txt {
        font-weight: 400;
        font-size: 15px;
        line-height: 188.5%;
        /* or 30px */
        padding-inline-start: 5px;

        color: #787878;
      }
      .check-box-con {
        width: 350px;
        margin: 24px auto 0px auto;
      }
      .kiosk-label {
        position: absolute;
        z-index: 999;

        font-weight: 700;
        font-size: 12px;
        line-height: 17px;
        /* identical to box height, or 142% */

        letter-spacing: 0.25px;
        left: 50px;
        bottom: 30px;
        color: #103f5e;
      }
      .kiosk-ddl {
        position: relative;
        margin-top: 24px;
      }
      div#attendance-code {
        width: 416px;
        // .vue-treeselect__menu{
        //   max-height: 110px;
        // }
        .vue-treeselect__menu::-webkit-scrollbar {
          width: 9px;
          height: 30px !important;
        }
        .vue-treeselect__menu::-webkit-scrollbar-track {
          background: #c7c7c7;
          padding-top: 30px !important;
          border-radius: 8.5px;
          -webkit-box-shadow: #ffff;
          margin-top: 21px !important;
          margin-bottom: 13px !important;
        }
        .vue-treeselect__menu::-webkit-scrollbar-thumb {
          background: #666666;
          border-radius: 8.5px;
        }
        margin: 0px auto 40px auto;
        .vue-treeselect__control {
          height: 55px;
          // position: relative;
          background: #f2f2f2;
          border-radius: 4px;
          border: none;
        }
        .vue-treeselect__option--highlight {
          background: none;
        }
        .vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #787878;
          margin-top: 20px;
          padding-inline-start: 15px;
        }
        .vue-treeselect__single-value {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          /* identical to box height, or 106% */

          letter-spacing: 0.25px;
          margin-inline-start: 12px;
          margin-top: 27px;
          /* Input text */

          color: #4a4a4a !important;
        }
        svg.vue-treeselect__x {
          display: none;
        }
        .vue-treeselect__control-arrow {
          color: #636161;
          margin-inline-end: 24px;
        }
      }
      .printCheckbox.custom-control.custom-checkbox {
        width: 380px;
        margin: auto;
      }
      .error-msg {
        margin: 8px auto 0px auto;
        width: 228px;

        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.25px;
        color: #f46a6a;
      }
      .first-msg {
        margin-inline-end: auto !important;
        margin-inline-start: auto !important;
        margin-bottom: 16px !important;
        text-align: center;
        line-height: 19px;
      }
      label.custom-control-label {
        font-weight: 400;
        font-size: 16px;
        line-height: 188.5%;
        color: #787878;
        padding-inline-start: 15px;
        margin: 0px auto 0px auto;
      }
      span.print-padge-txt1 {
        /* margin-top: -7px!important; */
        position: relative;
        top: -5px;
      }
      .second-msg {
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0.25px;
        width: 407px;
        margin: 0px auto 24px auto;
        color: #939393;
      }
      .pass-ques {
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        /* or 178% */
        width: 407px;
        text-align: center;
        letter-spacing: 0.25px;

        /* #939393 */
        margin: 0px auto 0px auto;
        color: #939393;
      }
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      margin: 40px auto 20px auto;
    }
    .action-btns {
      .submit-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 111px;
        height: 33px;
        color: #ffffff;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        margin-inline-end: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .cancel-btn {
        border: 1.5px solid #f46a6a;
        background: #ffffff;
        border-radius: 16.6275px;
        color: #f46a6a;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        width: 111px;
        height: 33px;
      }
    }
  }
  :disabled {
    cursor: not-allowed;
    opacity: 0.4 !important;
  }
}
</style>
